/** Тег, под которым service worker показывает проверочное окно: его не трогаем. */
const PROBE_TAG = "erp-probe";

/**
 * Убирает из шторки устройства уже показанные системные уведомления.
 *
 * Push показывает уведомление сам, даже когда ERP закрыта, и оно остаётся в
 * шторке, пока его не смахнут. Если человек прочитал его на другом устройстве,
 * здесь оно уже неактуально. Тег уведомления — его идентификатор (см.
 * SystemWebPushNotification на сервере), поэтому точечно закрывается ровно то,
 * что прочитано; `null` закрывает все, кроме проверочного.
 *
 * Не поддерживающий API браузер и отказ ничего не ломают: шторка — украшение,
 * истина остаётся в списке и счётчике.
 */
export async function closeShownNotifications(
  notificationId: string | null,
  container: Pick<ServiceWorkerContainer, "getRegistration"> | undefined = typeof navigator === "undefined"
    ? undefined
    : navigator.serviceWorker,
): Promise<void> {
  try {
    const registration = await container?.getRegistration();
    if (registration === undefined) return;
    const shown = await registration.getNotifications();
    for (const notification of shown) {
      if (notification.tag === PROBE_TAG) continue;
      if (notificationId === null || notification.tag === notificationId) notification.close();
    }
  } catch {
    // Браузер не даёт список показанных уведомлений — оставляем как есть.
  }
}
